import { ButtonUpsellProtected } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useConvertQuoteToInvoice } from '@features/invoices/hooks/quotes/useConvertQuoteToInvoice'
import { getQuoteRegularInvoiceDraft } from '@features/invoices/utils/depositInvoices/getQuoteRegularInvoiceDraft'
import { getDiscountModeTrackingValue } from '@features/invoices/utils/getDiscountModeTrackingValue'
import { getQuoteDiscountMode } from '@features/invoices/utils/getQuoteDiscountMode'

import { Scope } from '../../../../../../../../../../enums/scope'
import { TrackingContext } from '../../../../../../../../../../enums/trackingContext'
import { useOrganizationViewUrl } from '../../../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../../../utils/routing/reactRoute'
import { useQuote } from '../../../../../../contexts/quoteContext'

export const ConvertQuoteToInvoiceButton = (): ReactElement => {
  const { t } = useTranslation()
  const { quote } = useQuote()

  const { url: newInvoiceFromQuoteUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getInvoiceFromQuoteRoute(String(quote?.id)),
  )

  const { onConvertClick: onConvertToInvoiceClick } = useConvertQuoteToInvoice({
    convertToInvoiceUrl: newInvoiceFromQuoteUrl,
    existingInvoiceDraft: getQuoteRegularInvoiceDraft(quote),
    trackingDiscountMode: getDiscountModeTrackingValue(getQuoteDiscountMode(quote)),
    trackingEventName: 'XXX - Invoicing Core - Quote View - Convert to invoice button clicked',
    trackingOption: 'invoice',
  })

  return (
    <ButtonUpsellProtected
      onClick={onConvertToInvoiceClick}
      trackingContext={TrackingContext.QuoteConvertToInvoice}
      upsellScope={Scope.OfferConvertToInvoiceUpsell}
    >
      {t('quotes.view.convert_to_invoice')}
    </ButtonUpsellProtected>
  )
}
